module.exports = __webpack_public_path__ + "img/voice-chat.fb4451d6.jpg";